import { Instagram, MessageCircle, Phone } from "lucide-react";
import {
    INSTAGRAM_HANDLE,
    INSTAGRAM_URL,
    PHONE_DISPLAY,
    PHONE_INTL_DISPLAY,
    PHONE_TEL,
    WHATSAPP_URL,
} from "@/data/site";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="mt-8 rounded-t-[2.5rem] bg-cocoa text-cream"
        >
            <div className="mx-auto max-w-6xl px-4 py-14 text-center sm:px-6 sm:py-16">
                <img
                    src="/images/logo.jpg"
                    alt="Cakes'alot by Indu logo"
                    className="mx-auto size-16 rounded-full ring-1 ring-cream/30"
                />
                <p className="mt-5 font-serif text-2xl font-semibold sm:text-3xl">
                    Cakes'alot <span className="italic text-blush">by Indu</span>
                </p>
                <p className="mx-auto mt-3 max-w-sm text-sm leading-relaxed text-cream/60">
                    Handmade celebration cakes in Colombo, Sri Lanka. Delivery and
                    pickup are both available.
                </p>

                <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
                    <a
                        data-testid="footer-call-btn"
                        href={PHONE_TEL}
                        className="footer-btn"
                    >
                        <Phone className="size-4" />
                        {PHONE_DISPLAY}
                    </a>
                    <a
                        data-testid="footer-whatsapp-btn"
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="footer-btn"
                    >
                        <MessageCircle className="size-4" />
                        {PHONE_INTL_DISPLAY}
                    </a>
                    <a
                        data-testid="footer-instagram-btn"
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="footer-btn"
                    >
                        <Instagram className="size-4" />
                        {INSTAGRAM_HANDLE}
                    </a>
                </div>

                <p className="mt-10 text-xs text-cream/40">
                    © {new Date().getFullYear()} Cakes'alot by Indu · Made with love
                    in Ceylon
                </p>
            </div>
        </footer>
    );
}
